<template>
  <div class="p-styleguide">
    <page-title>This is a page title</page-title>

    <!-- <tabs>
      <tabs-item>This is a tab</tabs-item>
      <tabs-item :active="true">An active tab</tabs-item>
      <tabs-item>And another</tabs-item>
    </tabs>-->
    <section-block>
      <h1>This is heading 1</h1>
      <h2>This is heading 2</h2>
      <h3>This is heading 3</h3>
      <h4>This is heading 4</h4>
      <h5>This is heading 5</h5>
    </section-block>

    <section-block>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi qui suscipit vitae molestias reiciendis explicabo corrupti earum beatae minus veniam, ut illo sapiente dolorum fugit ipsam cum hic. Porro, harum!</p>
      <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quia ea ratione quasi! Labore nobis assumenda sint error, quibusdam amet, numquam neque laborum, asperiores odit tempora architecto vel sapiente veritatis tenetur! Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nisi libero ex odio architecto atque accusamus repudiandae ad necessitatibus nemo obcaecati odit, eligendi culpa id blanditiis. Dignissimos voluptatum exercitationem esse. Pariatur?</p>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem impedit nam ipsa quos tempore in, magni alias fuga enim molestias! Inventore maiores aliquid provident corporis temporibus sequi dolorum rerum quaerat?</p>
    </section-block>

    <section-block>
      <template slot="header">
        <h3>Cactus Logo</h3>
      </template>
      <cactus-logo></cactus-logo>
    </section-block>

    <section-block>
      <template slot="header">
        <h3>Loading indicator</h3>
      </template>
      <loading></loading>
    </section-block>

    <section-block>
      <template slot="header">
        <h3>Animations</h3>
      </template>
      <!-- <lottie-test></lottie-test> -->
    </section-block>

    <section-block>
      <template slot="header">
        <h3>Forms</h3>
      </template>

      <form action>
        <form-field label="Policy Title"></form-field>
        <form-field label="Choose Category"></form-field>
        <form-field label="Interest Groups"></form-field>
      </form>
    </section-block>

    <section-block>
      <template slot="header">
        <h3>File Icons</h3>
      </template>

      <file-icon type="pdf"></file-icon>
      <file-icon type="doc"></file-icon>
      <file-icon type="xls"></file-icon>
      <file-icon type="ppt"></file-icon>
      <file-icon type="link"></file-icon>
      <file-icon type="test"></file-icon>
      <file-icon type="test"></file-icon>
      <file-icon type="test"></file-icon>
    </section-block>

    <section-block>
      <template slot="header">
        <h3>Icons</h3>
      </template>

      <div class="p-styleguide__icon" v-for="icon in icons">
        <icon :name="icon" width="48" height="48"></icon>
        <span>{{icon}}</span>
      </div>
    </section-block>

    <section-block>
      <template slot="header">
        <h3>PDF Preview</h3>
      </template>

      <!-- <pdf-preview></pdf-preview> -->
    </section-block>

    <section-block>
      <template slot="header">
        <h3>File Upload</h3>
      </template>

      <file-upload
        name="document_file"
        @uploaded="onFileUploaded"
        :fileId="el.properties[propConfig.name]"
      ></file-upload>
    </section-block>

    <section-block>
      <template slot="header">
        <h3>Modal</h3>
      </template>

      <base-button :primary="true" @click="modalOpen = true">Open modal</base-button>
    </section-block>

    <modal v-if="modalOpen">
      <h2>This is a test modal</h2>
      <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Id placeat, enim eos atque consequatur sit quia nihil illum repellat modi suscipit excepturi? Assumenda quam, facere delectus cupiditate consequatur debitis necessitatibus.</p>
      <base-button :primary="true" @click="modalOpen = false">Close Modal</base-button>
    </modal>
  </div>
</template>

<script>
import CactusLogo from '@/components/CactusLogo';

import Dropdown from '@/components/Dropdown';
import PdfPreview from '@/components/PdfPreview';

export default {
  name: 'styleguide',

  data() {
    return {
      modalOpen: false,
      icons: [
        'book',
        'chart',
        'check',
        'cog',
        'cross',
        'dashboard',
        'delete',
        'dots',
        'download',
        'duplicate',
        'edit',
        'element-accordion',
        'element-button',
        'element-callout',
        'element-gallery',
        'element-heading',
        'element-image',
        'element-resource-list',
        'element-text-block',
        'element-video',
        'file',
        'grid',
        'hr',
        'hub',
        'list',
        'medal',
        'menu',
        'mixer',
        'move',
        'page',
        'people',
        'plus-circle',
        'pulse',
        'search',
        'shield',
        'signal',
        'spark',
        'stack',
        'star',
        'text',
        'tick',
        'logout',
      ],
    };
  },

  components: {
    CactusLogo,
    Dropdown,
    PdfPreview,
  },
};
</script>

<style lang="scss">
.p-styleguide {
  &__icon {
    display: inline-block;
    width: 25%;
    height: 100px;
    padding: 1em;
  }
}
</style>
